/// <amd-module name="Test/TestPlansLibrary/ColumnOptions/ColumnOptionsCommonUtils" />
import * as Resources from "Test/TestPlansLibrary/ColumnOptions/Resources";

export interface IColumnOptions {
    name: string;
    isWorkItemField: boolean;
    testCasesPivot: boolean; // set to true only if this is a non default column in the TestCases pivot
}

export interface IColumnOptionKeyValuePair {
    key: string;
    name: string;
}

export interface IWorkItemColumnOptions extends IColumnOptions {
    getDisplayValue(fieldValue: any): any;
}

export const WorkItemColumnOptions: { [id: string]: IWorkItemColumnOptions } = {
    "System.AssignedTo": {
        name: Resources.AssignedTo,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            if (fieldValue && fieldValue.identityRef) {
                return fieldValue.identityRef.displayName;
            }
            if (fieldValue && fieldValue.distinctDisplayName) {
                return fieldValue.distinctDisplayName;
            } else {
                return Resources.UnassignedIdentity;
            }
        }
    },
    "Microsoft.VSTS.TCM.AutomationStatus": {
        name: Resources.AutomationStatus,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "Microsoft.VSTS.TCM.AutomatedTestName": {
        name: Resources.AutomatedTestName,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "Microsoft.VSTS.Common.Priority": {
        name: Resources.Priority,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "Microsoft.VSTS.Build.IntegrationBuild": {
        name: Resources.IntegrationBuild,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "System.AreaPath": {
        name: Resources.AreaPath,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "System.IterationPath": {
        name: Resources.IterationPath,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "System.Tags": {
        name: Resources.Tags,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "System.TeamProject": {
        name: Resources.Project,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    },
    "System.CreatedBy": {
        name: Resources.CreatedBy,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            if (fieldValue && fieldValue.identityRef) {
                return fieldValue.identityRef.displayName;
            }
            if (fieldValue && fieldValue.distinctDisplayName) {
                return fieldValue.distinctDisplayName;
            }
            return "";
        }
    },
    "System.CreatedDate": {
        name: Resources.CreatedDate,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            let date = new Date(fieldValue);
            return date.toLocaleString();
        }
    },
    "System.ChangedBy": {
        name: Resources.ChangedBy,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            if (fieldValue && fieldValue.identityRef) {
                return fieldValue.identityRef.displayName;
            }
            if (fieldValue && fieldValue.distinctDisplayName) {
                return fieldValue.distinctDisplayName;
            }
            return "";
        }
    },
    "System.ChangedDate": {
        name: Resources.ChangedDate,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            let date = new Date(fieldValue);
            return date.toLocaleString();
        }
    },
    "System.State": {
        name: Resources.State,
        isWorkItemField: true,
        testCasesPivot: true,
        getDisplayValue: (fieldValue: any) => {
            return fieldValue;
        }
    }
};

export const CustomFieldColumn: IWorkItemColumnOptions = {
    name: Resources.CustomField,
    isWorkItemField: true,
    testCasesPivot: true,
    getDisplayValue: (fieldValue: any) => {
        if (fieldValue && fieldValue.identityRef) {
            return fieldValue.identityRef.displayName;
        }
        if (fieldValue && fieldValue.distinctDisplayName) {
            return fieldValue.distinctDisplayName;
        }
        return String(fieldValue);
    }
};

export function getCustomFieldName(columnOptionField: string) {
    let name = columnOptionField.substring(columnOptionField.indexOf(".") + 1);
    return {
        id: columnOptionField,
        name: name
    };
}

export function isCoreField(field: string): boolean {
    if (field.toLowerCase().startsWith("system.")) {
        return true;
    }
    return false;
}

export function isoobfield(field: string): boolean {
    if (field.toLowerCase().startsWith("microsoft.vsts.")) {
        return true;
    }
    return false;
}

//since old custom columns do not start with custom.
export function isCustomField(field: string): boolean {
    if (!isCoreField(field) && !isoobfield(field)) {
        return true;
    }
    return false;
}
